import React from 'react';

export function CampaignPausedBanner() {
  return (
    <div role="status" className="rounded-lg border border-amber-200 bg-amber-50 p-6 text-amber-900">
      <h2 className="text-lg font-semibold">This campaign is currently paused</h2>
      <p className="mt-2 text-sm">Please look for updates on the Aligned message board.</p>
    </div>
  );
}
